import v1 from './schemas/www.w3.org/2018/credentials/v1.json';
import education from './schemas/cdn.zedeid.com/credentials/microrewards/v2.00/education.json';
import base from './schemas/cdn.zedeid.com/credentials/microrewards/v3.00/base.json';
import hackathon from './schemas/cdn.zedeid.com/credentials/microrewards/v3.00/hackathon.json';
import membership from './schemas/cdn.zedeid.com/credentials/microrewards/v3.00/membership.json';
import qualification from './schemas/cdn.zedeid.com/credentials/microrewards/v3.00/qualification.json';
import raceAward from './schemas/cdn.zedeid.com/credentials/microrewards/v3.00/race-award.json';
import toolsdemo from './schemas/cdn.zedeid.com/credentials/microrewards/v2.00/toolsdemo.json';

export default {
    'https://www.w3.org/2018/credentials/v1': v1,
    'https://cdn.zedeid.com/credentials/microrewards/v2.00/education': education,
    'https://cdn.zedeid.com/credentials/microrewards/v3.00/base': base,
    'https://cdn.zedeid.com/credentials/microrewards/v3.00/hackathon': hackathon,
    'https://cdn.zedeid.com/credentials/microrewards/v3.00/membership': membership,
    'https://cdn.zedeid.com/credentials/microrewards/v3.00/qualification': qualification,
    'https://cdn.zedeid.com/credentials/microrewards/v3.00/race-award': raceAward,
    'https://cdn.zedeid.com/credentials/microrewards/v2.00/toolsdemo': toolsdemo,
};
